import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login({ onAuthed }) {
  const [emailOrName, setEmailOrName] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/auth/me`).then(() => navigate("/", { replace: true })).catch(() => {});
  }, []);

  const doLogin = async () => {
    try {
      const res = await api.post(`/auth/login`, { email_or_name: emailOrName, password });
      if (res.data?.token) localStorage.setItem('jwt_fallback', res.data.token);
      toast.success("Logged in");
      onAuthed?.(res.data.user);
      try { await api.get(`/auth/me`); } catch {}
      window.location.href = "/";
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    }
  };

  const handleKey = (e) => { if (e.key === "Enter") doLogin(); };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      {/* Subtle radial glow behind the card */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-sm space-y-6">
        {/* Branding */}
        <div className="text-center space-y-1">
          <h1 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-primary to-cyan-400 bg-clip-text text-transparent">
            Member Discounts
          </h1>
          <p className="text-sm text-muted-foreground">Sign in to view available discounts</p>
        </div>

        <Card className="border border-border/60 shadow-2xl">
          <CardHeader className="pb-4">
            <CardTitle className="text-xl" data-testid="login-title">Sign in</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="identifier" className="text-sm">Email or Username</Label>
              <Input
                id="identifier"
                data-testid="login-identifier-input"
                placeholder="Enter your email or username"
                value={emailOrName}
                onChange={(e) => setEmailOrName(e.target.value)}
                onKeyDown={handleKey}
                autoComplete="username"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-sm">Password</Label>
              <Input
                id="password"
                data-testid="login-password-input"
                placeholder="Enter your password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKey}
                autoComplete="current-password"
              />
            </div>
            <Button data-testid="login-submit-button" className="w-full" onClick={doLogin}>
              Sign in
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
